<template>
	<div class="main-wrapper">
		<!---Navigation-->
		<Navbar :user="user" :topbarColor="topbarColor" :title="titleBox" :logopsinet="require('@/assets/images/logo/psinet.png')" :logo="require('@/assets/images/logo/co1.png')" />
		<!---Sidebar-->
		<div v-if="verificateSesion">
			<SideBar v-if="role" parent=".main-wrapper" :sidebarLinks="sidebarLinks" />
			<!---Page Container-->
			<div class="main-container-fluid" :class="{'pspadd':!role}">
			<router-view></router-view>
			</div>
		</div>
	<vs-popup  title="Log In Required!!!" :active.sync="popupActivo">
			<p>
				Debe iniciar sesión si tiene algún problema, revise las credenciales de usuario...
			</p>
    </vs-popup>
	</div>
</template>

<script>

import Navbar from '@/layout/full/header/Navbar.vue';
import SideBar from '@/layout/full/sidebar/SideBar.vue';
import sidebarLinks from '@/layout/full/sidebar/sidebarlinks.js';
import axios from 'axios';

export default {
name: "MainContainer",
components: {
Navbar,
SideBar

},
data:() => ({
	topbarColor: "#fff",
	titleBox: "Asistencia Aculatamiento",
	logopsinet: "Psinet",
	sidebarLinks: sidebarLinks,
	access_token:'',
	user: {},
	role: false,
	popupActivo: false,
	error_msg: '',
}),
methods: {
	get_user(){
	this.access_token = localStorage.getItem("token")
	const url_api =  this.$store.state.url_api
    axios.get(url_api + 'role', {
		headers:{
		'Content-Type': 'application/x-www-form-urlencoded',
		'Authorization': `Bearer ${this.access_token}`
		}
	})
	.then(response => {
	this.user = response.data
	if (this.user.role == 'admin')
		this.role = true
	})
	.catch(error => {
	this.error = true
	this.error_msg = error.response.data
    })
	},
	verification(){
		this.access_token = localStorage.getItem("token")
		if (this.access_token == null){
		this.popupActivo = true
		}
	}
	},
	mounted(){
	this.get_user()
	this.verification()
	},
	computed: {
verificateSesion: function (){
			return localStorage.getItem('token') != null
		}
    }
}
</script>
<style>
	.pspadd{
		margin-left: 0px;
	}
	.container_auth{
		padding: 90px 15px 40px 15px;
	}
	 @media (max-width: 840px){
  .modal-container {
    width: 300px !important;
    height: auto !important;
    }
  }

  @media (max-width: 1169px){
    .modal-container {
      height: auto !important;
    }
  }

  @media (min-width: 1169px){
    .modal-container {
      width: 600px !important;
      height: 600px !important;
    }
  }
</style>